export default __webpack_public_path__ + "static/poster-9b5d059f1d5f2c7b5cc136c0b0d491f8.png";